import Constants from '../config/const';
import { loadSmilarWorks } from '../config/api';
import { openPanel, closePanel } from './panel';

export const showMoreLikeThis = (sourceId, index, source) => (dispatch, getState) => {
  let original;
  const { moreLikeThis: { works: moreWorks }, works, workDetails } = getState();
  switch (source) {
    case Constants.moreLikeThisSources.works: {
      original = works.works[index];
      break;
    }
    case Constants.moreLikeThisSources.canvas: {
      original = workDetails[sourceId];
      break;
    }
    default: {
      original = moreWorks[index];
      break;
    }
  }
  dispatch({
    type: Constants.moreLikeThis.set,
    sourceId,
    index,
    original
  });
  dispatch(closePanel({ kind: Constants.panelKinds.works }));
  setTimeout(() => {
    dispatch(openPanel({ kind: Constants.panelKinds.moreLikeThis }));
  }, 400);
};

export const showWorks = () => (dispatch) => {
  dispatch(closePanel({ kind: Constants.panelKinds.moreLikeThis }));
  setTimeout(() => {
    dispatch(openPanel({ kind: Constants.panelKinds.works }));
  }, 400);
};

export const hideMoreLikeThis = () => (dispatch) => {
  dispatch(closePanel({ kind: Constants.panelKinds.moreLikeThis }));
  dispatch({
    type: Constants.moreLikeThis.reset
  });
};

const loadedMoreLikeThis = (works) => ({
  type: Constants.moreLikeThis.loaded,
  works
});

export const loadMoreLikeThis = () => (dispatch, getState) => {
  dispatch({ type: Constants.moreLikeThis.loading });
  const { sourceId, source } = getState().moreLikeThis;
  loadSmilarWorks(sourceId).then((works) => {
    const { sourceId: sourceIdNew, source: sourceNew } = getState().moreLikeThis;
    if (sourceId === sourceIdNew && source === sourceNew) {
      dispatch(loadedMoreLikeThis(works));
    }
  });
};
